module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "AENL"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "JANUARY 12: Where Is Your Focus?"
    }
  }, [_c('h1', {
    staticClass: "chapter2",
    attrs: {
      "id": "pAHQml"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#AB_ch13",
      "id": "AB_cha13"
    }
  }, [_vm._v("JANUARY 12"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "chapter2a"
  }, [_vm._v("Where Is Your Focus?")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "ext",
    attrs: {
      "id": "pAfY"
    }
  }, [_c('em', [_vm._v("Surely you have granted him unending blessings and made him glad with the joy of your presence.")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pA_qi"
    }
  }, [_vm._v("—Psalm 21:6 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIV")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "A52Z"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_vm._v("Y")])]), _vm._v("our car won’t start. The weather forecast calls for sleet on your wedding day. Your spouse lost his job. You overslept, beginning your day with frenzy. You can think of many other difficult circumstances, right? What is your reaction when everything seems to be going wrong?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAEnQ"
    }
  }, [_vm._v("Almost everyone focuses on the problem: the old car, the less-than-ideal wedding weather, financial stress, time constraints. Another reaction is harder to pull off but pays more in dividends: focus on what you "), _c('em', [_vm._v("do")]), _vm._v(" have. You have friends who will drive you to work or a good public transportation system. You’re marrying the love of your life—regardless of rain or shine. Your spouse is healthy, and he can look for more work. Your day doesn’t need to be dictated by its beginning; it can still have a good ending. Do you see how focusing on what you have, rather than what you lack, can change your perspective?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pA6o2"
    }
  }, [_vm._v("When things aren’t going your way, or when you feel overwhelmed by life’s hardships, look at the blessings all around you. When everything seems to be going wrong, recognize the many, many things that are going right.")]), _vm._v(" "), _c('p', {
    staticClass: "left1",
    attrs: {
      "id": "pAUV3"
    }
  }, [_c('em', [_vm._v("Father, so much of my life is good and whole and wonderful. Thank You for all of it.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5d3ba6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter13.vue
// module id = 105
// module chunks = 0